var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 315.89363,
    height: 468.03704,
    viewBox: "0 0 315.89363 468.03704",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 227.82845,
    cy: 63,
    r: 63,
    fill: "#ff6884"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.8868,456.49895L3.83357,451.96966,.00203,132.46868c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301L144.60603,35.51506c10.65576-10.65479,27.42725-11.4248,39.01318-1.78662l82.60742,68.71826c6.73926,5.60596,10.54541,13.84863,10.44189,22.61427l-2.83838,240.28076,35.90381,49.86621,.07617,.10547,6.0835,52.72363-181.00684-11.53809Z",
    fill: "#f1f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.82826,109.90763v-14.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h20.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-20.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#007dff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.82826,224.90763v-54.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h30.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-30.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.16787,288.58856v-54.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h30.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-30.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.48494,353.21865c-3.72461-.13184-6.72803-3.1543-6.83838-6.87988l-1.55811-52.98145c-.06641-2.26172,.9126-4.36328,2.68604-5.76855,1.77344-1.4043,4.04443-1.87305,6.23096-1.29297l1.55811,.41602c3.09961,.82715,5.26465,3.64453,5.26465,6.85254v52.56641c0,1.94141-.76953,3.75391-2.1665,5.10254-1.33496,1.28906-3.07275,1.98926-4.91846,1.98926-.08594,0-.17188-.00098-.2583-.00391Z",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.82826,345.90813v-54.97461c0-3.88086,3.03955-6.99512,6.91943-7.09082l28.0083-.68262c3.88232-.05371,7.14893,2.99316,7.2627,6.88477l1.61328,55.65723c.05566,1.93262-.65527,3.76074-2.00293,5.14746-1.34668,1.38672-3.15332,2.15039-5.08643,2.15039h-29.62207c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.37599,383.47341l21.95245,39.02658,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59271-3.08905,12.39722,.04755,17.97342Z",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 225.9013,
    y: 454.31523,
    width: 71.25525,
    height: 1.00009,
    transform: "translate(-6.19314 3.61775) rotate(-.78329)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 225.27251,
    y: 445.26647,
    width: 67.55676,
    height: 1.00003,
    transform: "translate(-3.47451 2.03736) rotate(-.44761)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 224.70238,
    y: 436.6149,
    width: 64.63184,
    height: 1.00018,
    transform: "translate(-8.4868 5.1023) rotate(-1.11892)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 225.25602,
    y: 428.04499,
    width: 62.08985,
    height: 1.00055,
    transform: "translate(-14.08004 8.74133) rotate(-1.9017)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 224.68878,
    y: 420.0766,
    width: 59.659,
    height: 1.00061,
    transform: "translate(-14.61967 9.20207) rotate(-2.01348)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 222.25703,
    y: 412.00033,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 220.89,
    y: 405.3138,
    width: 56.44,
    height: 1.00006,
    transform: "translate(-4.73817 2.9469) rotate(-.6714)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 219.6271,
    y: 398.89655,
    width: 54.71588,
    height: 1.00055,
    transform: "translate(-13.11789 8.41613) rotate(-1.9017)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 218.32372,
    y: 391.50023,
    width: 54.00928,
    height: 1.00015,
    transform: "translate(-6.85168 4.3723) rotate(-1.00705)",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 216.60908,
    y: 384.90729,
    width: 51.73132,
    height: 1.00049,
    transform: "translate(-11.9198 7.76169) rotate(-1.78991)",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 215.07709,
    y: 378.25032,
    width: 51.25244,
    height: 1.00006,
    transform: "translate(-3.68707 2.36856) rotate(-.55951)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.32826,357.40813v-67.81543c0-3.91113,3.18164-7.09277,7.09229-7.09277h32.81592c3.91064,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18115,7.0918-7.0918,7.0918h-32.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#007dff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.8868,456.49895l-118.09033-3.7002-.46826-.03027v-44.95703c0-5.68555,64.62549-10.31152,70.31104-10.31152h57.37793c5.68555,0,10.31104,4.62598,10.31104,10.31152v48.68848h-.5l-18.94141-.00098Z",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M215.32826,234.40812v-51.81592c0-3.91064,3.18164-7.09229,7.09229-7.09229h10.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v51.81592c0,3.91016-3.18115,7.0918-7.0918,7.0918h-10.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226.32845,461.49999l-3-44-9-42-2.5-11.5h0c-5.13733-3.49338-12.05536,.39255-11.74512,6.59735l.24512,4.90265,9,42,3,44",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtHome);
export default __webpack_public_path__ + "static/media/at_home.6df7f3d595c9057e88984bc7d63e7743.svg";
export { ForwardRef as ReactComponent };